var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('dynamic-form',{attrs:{"formData":_vm.form,"fill-data":_vm.fillData},on:{"submit":_vm.submit,"change":_vm.change,"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }